import Loading from "web/Layout/Common/Loading";

import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";

import MainHeaderDashboard from "./MainHeaderDashboard";
import MainHeaderDefault from "./MainHeaderDefault";

const MainHeaderContainer = () => {
  const { data: company, isLoading } = useGetCompanyDetailsQuery();
  const hasDashboardEnabled = company?.enableDashboard;
  const shouldShowMessage = company?.displayMessageOneTimeLossPoints || false;

  if (isLoading) {
    return <Loading />;
  }

  return hasDashboardEnabled ? (
    <MainHeaderDashboard shouldShowMessage={shouldShowMessage} />
  ) : (
    <MainHeaderDefault shouldShowMessage={shouldShowMessage} />
  );
};

export default MainHeaderContainer;
